import { Badge } from "@promptwatch/ui/components/badge";
import { Card } from "@promptwatch/ui/components/card";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { GlossaryDefinition } from "@/components/glossary-definition";
import type { GlossaryTerm } from "@/data/glossary";

interface TermCardProps {
  term: GlossaryTerm;
  variant?: "default" | "compact";
}

export function TermCard({ term, variant = "default" }: TermCardProps) {
  const categoryColor = {
    AI: "bg-blue-100 text-blue-800",
    SEO: "bg-green-100 text-green-800",
    GEO: "bg-purple-100 text-purple-800",
    Marketing: "bg-orange-100 text-orange-800",
    Analytics: "bg-pink-100 text-pink-800",
  };

  if (variant === "compact") {
    return (
      <Link href={`/glossary/${term.slug}`} className="group">
        <div className="bg-white rounded-lg p-4 border border-gray-200 hover:shadow-md hover:border-gray-300 transition-all duration-200">
          <div className="flex items-start justify-between mb-2">
            <h3 className="font-medium text-gray-900 group-hover:text-primary transition-colors line-clamp-1">{term.title}</h3>
            <Badge className={`text-xs ${categoryColor[term.category]} border-0`}>{term.category}</Badge>
          </div>
          <div className="text-sm text-gray-600 line-clamp-2">
            <GlossaryDefinition definition={term.definition} />
          </div>
          {/* <div className="flex items-center justify-end mt-2">
            <ArrowRight className="h-4 w-4 text-gray-400 group-hover:text-primary group-hover:translate-x-1 transition-all" />
          </div> */}
        </div>
      </Link>
    );
  }

  return (
    <Link href={`/glossary/${term.slug}`}>
      <Card className="group bg-white rounded-lg border border-gray-200 px-6 py-5 hover:shadow-sm hover:border-gray-300 transition-all duration-200 cursor-pointer h-full">
        <div className="flex items-start justify-between">
          <h3 className="text-lg font-semibold text-gray-900 group-hover:text-primary transition-colors line-clamp-1">{term.title}</h3>
        </div>
        <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 mb-1">{term.description}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Badge className={`text-xs ${categoryColor[term.category]} border-0`}>{term.category}</Badge>
            <span className="text-xs text-gray-500">Updated {new Date(term.lastUpdated).toLocaleDateString()}</span>
          </div>
          <ArrowRight className="h-4 w-4 text-gray-400 group-hover:text-primary group-hover:translate-x-1 transition-all" />
        </div>
      </Card>
    </Link>
  );
}
